module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-886-min.cd19b386.jpg";